import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';

interface IChangeBankDetailsModalContext {
  account: any;
}
@Component({
  selector: 'app-change-bank-details-modal',
  templateUrl: './change-bank-details-modal.component.html',
  styleUrls: ['./change-bank-details-modal.component.scss'],
})
export class ChangeBankDetailsModalComponent implements OnInit, OnChanges {
  banks: any;
  selectedBank: any;
  accountName: string;
  accountNumber: string;
  ibanNumber: string;
  sortCode: string;
  intermediaryBankSwiftCode;
  bankAddress;
  error: any;
  success: any;
  pending = false;

  constructor(
    public modal: SuiModal<IChangeBankDetailsModalContext, any, void>,
    private walletService: EwalletService
  ) {}

  ngOnInit() {
    this.getBanks();
    console.log(this.modal.context.account);
  }

  dataToJSON(data: any) {
    try {
      const jsonData = JSON.parse(data);
      return jsonData;
    } catch (error) {
      return null; // or handle the error in another way
    }
  }

  getBanks() {
    this.walletService
      .getBanks({
        currency: this.modal.context.account.currencyShortName.toLowerCase(),
      })
      .subscribe((res) => {
        this.banks = res;
      });
  }

  submit() {
    this.pending = true;
    let body;
    if (this.modal.context.account.currencyShortName.includes('DOLLAR')) {
      body = {
        bankName: this.selectedBank,
        bankAccountName: this.accountName,
        bankAccountNumber: this.accountNumber,
        routingNumber: this.ibanNumber ? this.ibanNumber : '',
        sortCode: this.sortCode ? this.sortCode : '',
        intermediarySortCode: this.intermediaryBankSwiftCode
          ? this.intermediaryBankSwiftCode
          : '',
        bankPhysicalAddress: this.bankAddress ? this.bankAddress : '',
      };
    } else {
      body = {
        bankId: this.selectedBank.optionId,
        bankName: this.selectedBank.optionName,
        bankAccountName: this.accountName,
        bankAccountNumber: this.accountNumber,
      };
    }
    const params = {
      customerWalletId: this.modal.context.account.customerWalletId,
      body,
    };
    this.walletService
      .changeBankDetails(params.customerWalletId, { body: params.body })
      .subscribe(
        (res) => {
          console.log({ res });
          this.pending = false;
          this.modal.approve(null);
        },
        (error) => {
          this.pending = false;
          console.log({ error });
          this.error = error;
        }
      );
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if (changes.modal && changes.modal.currentValue) {
      const accountChanges = changes.modal.currentValue.account;
      if (accountChanges) {
        this.getBanks();
      }
    }
  }
}

export class ChangeBankDetailsModal extends ComponentModalConfig<
  IChangeBankDetailsModalContext,
  void,
  void
> {
  constructor(account: any, size: ModalSize = ModalSize.Mini) {
    super(ChangeBankDetailsModalComponent, { account });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
